<template>
  <div v-if="placementExists && graduateExists">
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <h6 class="header-pretitle">Details</h6>
          <h1 class="header-title">Placement {{ placement.number }}</h1>
        </div><!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <div class="container-fluid container-boxed">
      <placements-single-details-card/>

      <placements-single-settings-card v-if="$userIsAdmin || $userIsCoordinator"/>

      <placements-single-download-pdp/>

      <template v-if="showPlacementComponentCards">
        <div class="decorative-divider"></div>

        <placements-single-start-component-card/>

        <placements-single-mid-point-card/>

        <placements-single-end-component-card/>
      </template>

      <div class="decorative-divider"></div>

      <LogCard v-if="$userIsAdmin" type="placement" />

      <LogDrawer v-if="$userIsAdmin" type="placement" :target="graduatePlacement"/>

      <placements-end-component-review :onPlacementsSingle="true"/>

      <ladda-button
        v-if="showAcknowledgeButton"
        :click="handleAcknowledgeCapabilitiesRequiringDevelopment"
        class="btn btn-sm btn-outline-warning">
          Acknowledge Capabilities Requiring Development
      </ladda-button>
    </div><!-- /.container-fluid -->
  </div>
</template>

<script>
import { placementComputed, placementMethods, graduateComputed, graduateMethods } from 'vx/helpers'
import { helpers } from 'mixins/graduates'
import { alert } from 'utils'
import PlacementsSingleSettingsCard from './PlacementsSingleSettingsCard'
import PlacementsSingleDetailsCard from './PlacementsSingleDetailsCard'
import PlacementsSingleDownloadPdp from './PlacementsSingleDownloadPdp'
import PlacementsSingleStartComponentCard from './PlacementsSingleStartComponentCard'
import PlacementsSingleEndComponentCard from './PlacementsSingleEndComponentCard'
import PlacementsSingleMidPointCard from './PlacementsSingleMidPointCard'
import PlacementsEndComponentReview from './PlacementsEndComponentReview'
import { LogCard, LogDrawer } from 'components/log'

export default {
  mixins: [helpers],

  props: {
    placementId: {
      required: true,
      type: Number
    },

    graduateId: {
      required: false,
      type: Number
    }
  },

  components: {
    PlacementsSingleSettingsCard,
    PlacementsSingleDetailsCard,
    PlacementsSingleStartComponentCard,
    PlacementsSingleEndComponentCard,
    PlacementsSingleDownloadPdp,
    PlacementsEndComponentReview,
    PlacementsSingleMidPointCard,
    LogCard,
    LogDrawer
  },

  async created () {
    await Promise.all([
      this.getGraduate(this.graduateId || this.$user.id),
      this.getPlacement({
        graduate: this.graduateId || this.$user.id,
        placement: this.placementId
      })
    ])
  },

  computed: {
    ...graduateComputed,
    ...placementComputed,

    graduatePlacement () {
      return { id: this.placement.graduate_placement_id }
    },

    showPlacementComponentCards () {
      return (this.$userIsManager && this.currentPlacementManager) || !this.$userIsManager
    },

    /**
     * Only show the button if the first placement didn't have capabilities_requiring_development
     */
    showAcknowledgeButton () {
      return this.$userIsAdmin && this.firstPlacement.underperforming && this.firstPlacement.acknowledged_capabilities_requiring_development === false && this.placement.acknowledged_capabilities_requiring_development === false
    }
  },

  methods: {
    ...placementMethods,
    ...graduateMethods,

    async handleAcknowledgeCapabilitiesRequiringDevelopment () {
      const confirm = await alert.confirm({
        text: 'By acknowledging the underperforming graduate they will no longer show up on the admin dashboard for this placement\'s score.'
      })

      if (confirm) {
        try {
          await this.acknowledgeCapabilitiesRequiringDevelopment({ graduate: this.graduate, placement: this.placement, payload: { acknowledged_capabilities_requiring_development: true } })
          this.setPlacementProperty({ property: 'acknowledged_capabilities_requiring_development', value: true })
        } catch (error) {
          this.$noty.error('unable to acknowledge capabilities requiring development')
        }
      }
    }
  }
}
</script>
